import { IService } from '../../../../../models/IService';
import ServiceImageTitle from '../../../components/ServiceImageTitle';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Dialog, Typography } from '@mui/material';
import Alarm from '@mui/icons-material/Alarm';
import EventAvailable from '@mui/icons-material/EventAvailable';
import Refresh from '@mui/icons-material/Refresh';
import WidgetConfirmButton from '../../../components/WidgetConfirmButton';

interface ServiceInfoDialogProps {
    open: boolean;
    onClose: () => void;
    service: IService | null;
    onChoose: () => void;
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        background: 'transparent',
        boxShadow: 'none',
        padding: 0,
        borderRadius: '5px',
        wordBreak: 'break-word',

        '& .dialog-content': {
            backgroundColor: theme.palette.grey[100],
            borderRadius: '5px',

            '& .service-name': {
                color: theme.palette.widget.text,
                fontSize: '24px',
                padding: theme.spacing(2, 2, 0)
            },

            '& .duration': {
                padding: theme.spacing(2),
                display: 'flex',
                alignItems: 'end',
                fontSize: '16px',
                color: theme.palette.widget.text,

                '& .MuiSvgIcon-root': {
                    width: '20px',
                    marginRight: '2px'
                }
            },

            '& .MuiTypography-root.description-text': {
                color: theme.palette.widget.text,
                fontSize: '16px',
                padding: theme.spacing(0, 2, 2)
            }
        },

        '& .cancel-button': {
            color: theme.palette.widget.title,
            fontSize: '14px',

            '& .MuiSvgIcon-root': {
                marginRight: theme.spacing(1)
            },

            '&:hover': {
                background: 'none'
            }
        }
    }
}));

const ServiceInfoDialog = ({ open, onClose, service, onChoose }: ServiceInfoDialogProps) => (
    <StyledDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <Box className="dialog-content" id="description-modal">
            <ServiceImageTitle service={service} />
            {service?.images.length === 0 && <Typography className="service-name">{service.name}</Typography>}
            <Box className="duration">
                <Alarm />
                {service?.duration}m
            </Box>
            <Typography className="description-text">{service?.description}</Typography>
            <WidgetConfirmButton onClick={onChoose}>
                <EventAvailable />
                Yes, I&apos;d like this Service
            </WidgetConfirmButton>
        </Box>
        <Button onClick={onClose} className="cancel-button">
            <Refresh />
            Change Service
        </Button>
    </StyledDialog>
);

export default ServiceInfoDialog;
